import { getCompanyConfigOld } from 'lib/api/company';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { hasAnyPermissions } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthState } from 'services/redux/authSlice';

import ArrearsComitee from './components/ArrearsComitee';
import CollectionDocuments from './components/Documents';
import CollectionsHome from './components/Home';
import LegalCollections from './components/LegalCollections';
import CollectionsManagements from './components/Managements';
import NotificationsCalendar from './components/NotificationsCalendar';
import VerificationModule from './components/Verification';
import VerificationByOperationModule from './components/VerificationByOperation';
import WriteOffs from './components/WriteOffs';

const Collection = () => {
  const dispatch = useDispatch();
  const { subPage } = useParams<{ page: string; subPage: string }>();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [verificationByDocument, setVerificationByDocument] = useState(false);
  const tabs: {
    label: string;
    component: any;
    path: string;
    index: number;
    disabled?: boolean;
  }[] = [];
  if (hasAnyPermissions(user, ['collections_view'])) {
    tabs.push({
      label: 'Inicio',
      component: <CollectionsHome />,
      path: 'home',
      index: 0,
    });
    tabs.push({
      label: 'Documentos',
      component: <CollectionDocuments />,
      path: 'documents',
      index: 1,
    });
    tabs.push({
      label: 'Gestiones',
      component: <CollectionsManagements />,
      path: 'management',
      index: 2,
    });
    tabs.push({
      label: 'Calendario',
      component: <NotificationsCalendar />,
      path: 'notificationsCalendar',
      index: 3,
    });
  }
  if (hasAnyPermissions(user, ['financing_verification_view'])) {
    tabs.push({
      label: 'Verificaciones',
      component: verificationByDocument ? (
        <VerificationModule />
      ) : (
        <VerificationByOperationModule />
      ),
      path: 'verification',
      index: 4,
    });
  }
  if (hasAnyPermissions(user, ['collections_arrears_comitee_read'])) {
    tabs.push({
      label: 'Comité de mora',
      component: <ArrearsComitee />,
      path: 'arrearsComitee',
      index: 5,
      disabled: !hasAnyPermissions(user, ['collections_arrears_comitee_read']),
    });
  }
  if (hasAnyPermissions(user, ['financing_legal_collection_view'])) {
    tabs.push({
      label: 'Cobranza judicial',
      component: <LegalCollections />,
      path: 'legalCollection',
      index: 6,
    });
  }
  if (hasAnyPermissions(user, ['financing_write_off_view'])) {
    tabs.push({
      label: 'Castigos',
      component: <WriteOffs />,
      path: 'writeOff',
      index: 7,
    });
  }

  const [loading, setLoading] = useState(true);
  const [companyTabs, setCompanyTabs] = useState<any>([]);
  const navigate = useNavigate();

  const [startValue, setStartValue] = useState(0);
  const handleNavigation = (index: number) => {
    navigate(`/finance/collections/${companyTabs[index].path}`);
  };

  const setUpTabs = async () => {
    const newProfileTabs: any = [...tabs];
    let startValueDefault = 0;
    startValueDefault = newProfileTabs.findIndex(
      (x: any) => x.path === subPage,
    );
    setCompanyTabs(newProfileTabs);
    setStartValue(startValueDefault === -1 ? 0 : startValueDefault);
    const config = await getCompanyConfigOld(
      dispatch,
      'system_verification_by_document',
    );
    const byDocument = config === '1';
    setVerificationByDocument(byDocument);
    if (byDocument) {
      setCompanyTabs([
        ...newProfileTabs,
        {
          label: 'Verificaciones',
          component: <VerificationModule />,
          path: 'verification',
          index: 4,
        },
      ]);
    } else {
      setCompanyTabs([
        ...newProfileTabs,
        {
          label: 'Verificaciones',
          component: <VerificationByOperationModule />,
          path: 'verificationByOperation',
          index: 4,
        },
      ]);
    }
    setLoading(false);
  };

  useEffect(() => {
    void setUpTabs();
  }, []);

  if (loading) return <CenteredCircularProgress type="layout" />;
  return (
    <div>
      <EnhancedTab
        startValue={startValue}
        tabs={tabs}
        onTabChange={handleNavigation}
      />
    </div>
  );
};

export default Collection;
